'use client';

import { useTheme as NextUseTheme } from '@teispace/next-themes';
import { useCallback } from 'react';

export enum ThemeType {
  LIGHT = 'light',
  DARK = 'dark',
}

export type TTheme = {
  mode: ThemeType;
  toggle: () => void;
};

export const useTheme = (): TTheme => {
  const { resolvedTheme: theme, setTheme } = NextUseTheme();

  const change = useCallback((mode: ThemeType) => setTheme(mode), [setTheme]);

  const toggle = useCallback(() => {
    const newTheme = theme === ThemeType.LIGHT ? ThemeType.DARK : ThemeType.LIGHT;
    change(newTheme);
  }, [theme, change]);

  return { mode: theme as ThemeType, toggle };
};
